import { useCallback, useEffect, useMemo, useState } from 'react';
import { tagged } from '@code-expert/prelude';
import { useDeepCompareMemoize } from '@code-expert/react';
export const connectionAdt = tagged.build();
export const useConnection = (socket) => {
    const getDefault = useCallback(() => socket.connected
        ? connectionAdt.wide.connected(socket.recovered ? 'recovered' : 'new')
        : connectionAdt.connecting('new'), [socket]);
    const [connection, setConnection] = useState(getDefault);
    useEffect(() => {
        const onConnect = () => void setConnection(getDefault);
        const onDisconnect = (reason) => void setConnection({
            'io server disconnect': connectionAdt.connectError(reason),
            'io client disconnect': connectionAdt.connectError(reason),
            'ping timeout': connectionAdt.connecting('recovering'),
            'transport close': connectionAdt.connecting('recovering'),
            'transport error': connectionAdt.connecting('recovering'),
            'parse error': socket.active
                ? connectionAdt.connecting('recovering')
                : connectionAdt.disconnected(reason),
        }[reason]);
        // Socket.connected might change between render and useEffect.
        setConnection(getDefault);
        socket.on('connect', onConnect);
        socket.on('disconnect', onDisconnect);
        return () => {
            socket.off('connect', onConnect);
            socket.off('disconnect', onDisconnect);
        };
    }, [socket, getDefault]);
    return useMemo(() => connection, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useDeepCompareMemoize([connection]));
};
//# sourceMappingURL=useConnection.js.map